import {
  IContainerSearchResult,
  IContainerSearchTyreFilter,
} from '~/purchase/types';

export const buildLookupTables = (offers: IContainerSearchResult['offers']) => {
  return offers.reduce(
    (acc, offer) => {
      // Brands
      acc.brandsLookup[offer.tyre.brand.id] = offer.tyre.brand;

      // Seasons
      if (offer.tyre.season) {
        acc.seasonsLookup[offer.tyre.season.id] = offer.tyre.season;
      }

      // EAN
      if (offer.tyre.ean) {
        acc.eanLookup[offer.tyre.ean] = offer.tyre.ean;
      }

      // Dimensions
      if (offer.tyre.dimension) {
        acc.dimensionLookup[offer.tyre.dimension.fullSize] =
          offer.tyre.dimension.fullSize;
      }

      return acc;
    },
    {
      brandsLookup: {} as Record<string, (typeof offers)[0]['tyre']['brand']>,
      seasonsLookup: {} as Record<string, (typeof offers)[0]['tyre']['season']>,
      eanLookup: {} as Record<string, (typeof offers)[0]['tyre']['ean']>,
      dimensionLookup: {} as Record<
        string,
        (typeof offers)[0]['tyre']['dimension']['fullSize']
      >,
    },
  );
};

export const filterOffers = (
  offers: IContainerSearchResult['offers'],
  filter?: IContainerSearchTyreFilter,
): IContainerSearchResult['offers'] => {
  if (!filter) {
    return offers;
  }

  return offers.filter((offer) => {
    return (
      (filter.identifier
        ? offer.tyre.dimension.fullSize
            .toLowerCase()
            .includes(filter.identifier.toLowerCase()) ||
          offer.tyre.ean === filter.identifier
        : true) &&
      (filter.brand ? offer.tyre.brand.id === filter.brand : true) &&
      (filter.season ? offer.tyre.season.id === filter.season : true)
    );
  });
};

export const toRequestPayload = (
  formData: Record<string, { quantity: number }>,
): Array<{ ean: string; quantity: number }> => {
  const payload: Array<{ ean: string; quantity: number }> = [];
  for (const ean in formData) {
    if (formData[ean].quantity) {
      payload.push({ ean, quantity: formData[ean].quantity });
    }
  }
  return payload;
};
